import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import { DEFAULT_THEME } from './config';
import type { TFileLink, TState, TIcons } from './models';
import { getIcon, convertTheme } from './helpers';

export const FileLinkV2: FC<TFileLink> = ({
    Text,
    Link,
    fileName,
    fileSize,
    fileType,
    config,
    link,
    iconColor,
    marginBottom = true,
    styles,
    className,
    theme = DEFAULT_THEME,
    hideFileSize,
    noUnderline,
    convertBytes,
}) => {
    const [state, setState] = useState<TState>();

    /* istanbul ignore next */
    useEffect(() => {
        if (!fileSize || !fileType) {
            const xhr = new XMLHttpRequest();
            xhr.open('HEAD', link, true);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === xhr.DONE) {
                    const contentSize = xhr.getResponseHeader('Content-Length');
                    const contentType = xhr.getResponseHeader('Content-Type')?.split('/').pop();

                    setState({
                        fileSize: contentSize ? +contentSize : undefined,
                        fileType: contentType,
                    });
                }
            };
            xhr.send();
        }
    }, [fileSize, fileType, link]);

    const fileNameByLink = link.split('/').pop();
    const fileExtByLink = (fileNameByLink || '').split('.').pop();
    const convertedSize = convertBytes(fileSize || state?.fileSize);

    const icon = getIcon(
        (fileType || state?.fileType || fileExtByLink || 'unknown') as TIcons,
        iconColor
    );

    const wrapClassName = cn(className, styles.wrap, {
        [styles.wrapMargin]: marginBottom,
        [styles.noUnderline]: noUnderline,
    });

    return (
        <div className={wrapClassName}>
            <Text styler={{ margin: 0 }} theme={theme} view={config.link.view}>
                <Link href={link} target="_blank" theme={convertTheme(theme)}>
                    {icon}
                    {fileName || fileNameByLink}
                </Link>
            </Text>
            {!hideFileSize && (
                <Text
                    data-test-id="file-link-size"
                    kind="caption"
                    styler={{ marginBottom: 4, marginTop: 0 }}
                    theme={theme}
                    view={config.size.view}
                >
                    {convertedSize || <>&nbsp;</>}
                </Text>
            )}
        </div>
    );
};
